import { render, staticRenderFns } from "./ThemeToggleComponent.vue?vue&type=template&id=037741b4&scoped=true&"
import script from "./ThemeToggleComponent.vue?vue&type=script&lang=js&"
export * from "./ThemeToggleComponent.vue?vue&type=script&lang=js&"
import style0 from "./ThemeToggleComponent.vue?vue&type=style&index=0&id=037741b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037741b4",
  null
  
)

export default component.exports